export const CHART_CATALOG_ID = 'https://risksmart.app/a2ui/catalogs/chart/v1';

export const CHART_SURFACE_ID = 'agent-chart';

export const CHART_COMPONENT_NAME = 'Chart';

export const CHART_ROOT_ID = 'root';

export const MAX_SERIES = 8;
export const MAX_POINTS = 50;
export const MAX_LABEL = 120;

export const CHART_TYPES = [
  'bar',
  'horizontalBar',
  'line',
  'spline',
  'area',
  'pie',
  'donut',
] as const;
export type ChartType = (typeof CHART_TYPES)[number];

interface ChartSeries {
  name: string;
  data: (number | null)[];
}

export interface ChartProps {
  chartType: ChartType;
  title?: string;
  categories?: string[];
  series: ChartSeries[];
  isStacked?: boolean;
}
